module.exports = __webpack_public_path__ + "static/img/cabinet5_5.5b5856a9.gif";